<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择产品工艺"
      width="900px"
      top="5vh">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :sel-reset="true"
        :columns="columns"
        module="basic"
        url="rtRouteMaterials"
        @select="selectMaterialsRoute"
        @reset="resetHandle">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="工艺路线" prop="routingName">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: {TableSelect},
    data() {
      return {
        dialogVisible: false,
        filter: {
          routingName: "",
          materialNo: "",
        },
        columns: [
          {
            title: "编号",
            key: "routeMaterialNo",
            align:"center",
            width: 140,
          },
          {
            title: "工艺路线",
            key: "routingName",
            width: 160,
          },
          {
            title: "物料编号",
            key: "materialNo",
            align:"center",
            width: 160,
          },
          {
            title: "物料名称",
            key: "materialName",
          },
          {
            title:"版本号",
            key: "versionNo",
            width: 80,
            align: "center",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
          },
        ],
      };
    },
    methods: {
      open(materialNo) {
        this.dialogVisible = true;
        this.filter.materialNo = materialNo;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },

      selectMaterialsRoute(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      // 重置特殊处理
      resetHandle() {
        this.filter.routingName = "";
        this.$refs.tableSelect.loadData();
      },
    },
  };
</script>
